import { type SetElementType } from '../utils/types/set-element-type';

/** Sort direction values. */
export const sortDirectionValues = new Set([
  'asc',
  'desc',
] as const);

/** Sort direction. */
export type SortDirection = SetElementType<typeof sortDirectionValues>;
